// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1306":"60966687","6533":"b37ca6c0","8902":"ac6bb9c8"}[chunkId] + ".chunk.css";
};